import React from 'react';

export default function WizardSectionNav({ sections, currentStep, statuses, onSelect }) {
  return (
    <div className='WizardSectionNav'>
      <div className='WizardSectionNavCount'>SECTIONS · {sections.length}</div>
      <ul className='WizardSectionNavList'>
        {sections.map((s, i) => {
          const status = statuses[i];
          const circle =
            status === 'EDITING' ? i + 1 : status === 'INCOMPLETE' ? '!' : <i className='fa-solid fa-check' />;
          return (
            <li
              key={i}
              className={`WizardSectionNavItem status-${status.toLowerCase()}${i === currentStep ? ' active' : ''}`}
              onClick={() => onSelect(i)}
            >
              <span className='WizardSectionNavCircle'>{circle}</span>
              <span className='WizardSectionNavText'>
                <span className='WizardSectionNavName'>{s.label}</span>
                <span className='WizardSectionNavStatus'>{status}</span>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
